import { ACTION_TYPES, MUTATION_TYPES } from './types';
import periodEndService from './../api';

export default {
  async [ACTION_TYPES.RESET](context) {
    context.commit(MUTATION_TYPES.RESET);
  },
  async [ACTION_TYPES.GET_ACADEMIC_YEARS]({ commit }) {
    const result = await periodEndService.getAcademicYears();
    commit(MUTATION_TYPES.SET_ACADEMIC_YEARS, result);
  },
  async [ACTION_TYPES.GET_MONTHS](context, payload) {
    const { mappedMonths } = await periodEndService.getMonths(payload);
    context.commit(MUTATION_TYPES.SET_MONTHS, mappedMonths);
  },
  async [ACTION_TYPES.GET_SPECIALIST](
    context,
    { academicYearId, monthNumber, payload }
  ) {
    const { data: result } = await periodEndService.getSpecialists(
      academicYearId,
      monthNumber,
      payload
    );
    context.commit(MUTATION_TYPES.SET_SPECIALIST, result);
  },
  async [ACTION_TYPES.Get_PROVIDERS](context, { academicYearId, payload }) {
    const { data: result } = await periodEndService.getProviders(
      academicYearId,
      payload
    );
    context.commit(MUTATION_TYPES.SET_PROVIDERS, result);
  },
  async [ACTION_TYPES.GET_SERVICES](context, { payload }) {
    const { data: result } = await periodEndService.getServices(payload);
    context.commit(MUTATION_TYPES.SET_SERVICES, result);
  },
  async [ACTION_TYPES.GET_CENTERS](
    context,
    { academicYearId, monthNumber, payload }
  ) {
    const { data: result } = await periodEndService.getCenters(
      academicYearId,
      monthNumber,
      payload
    );
    context.commit(MUTATION_TYPES.SET_CENTERS, result);
  },
  async [ACTION_TYPES.GET_PERIOD_END_SUMMARY](
    context,
    { payload, persistSpecialistFilter = false }
  ) {
    const { data: result } = await periodEndService.searchPeriodEndSummary(
      payload
    );
    context.commit(MUTATION_TYPES.SET_RESULT, {
      ...result,
      persistSpecialistFilter,
    });
    if (!persistSpecialistFilter) {
      context.commit(MUTATION_TYPES.SET_RESULT_SPECIALIST_INFO, result);
    }
  },
  async [ACTION_TYPES.FINALIZE_PERIOD](_, { payload }) {
    const { data: result } = await periodEndService.finalizePeriod(payload);
    return result;
  },
  async [ACTION_TYPES.START_ENDED_PERIOD](_, { payload }) {
    const { data: result } = await periodEndService.startEndedPeriod(payload);
    return result;
  },
};
